import {POST} from "../../../Hooks/RequestV2";
import {WZDownloadFormat, WZDownloadedFile} from "./types";

export class WZApiError extends Error {
    constructor(public readonly status: number, message: string) {
        super(message);
        this.name = 'WZApiError';
    }
}

function getFileName(contentDisposition: string | null, fallback: string): string {
    const fileNameMatch = contentDisposition?.match(/filename\*?=(?:UTF-8'')?["']?([^;"']+)/i);

    if (!fileNameMatch?.[1]) {
        return fallback;
    }

    return decodeURIComponent(fileNameMatch[1]);
}

export async function downloadWZFile(id: number, format: WZDownloadFormat): Promise<WZDownloadedFile> {
    const response = await POST('/user/wz/download-file', {id, format});

    if (!response.ok) {
        throw new WZApiError(response.status, 'WZ file download failed');
    }

    return {
        blob: await response.blob(),
        fileName: getFileName(response.headers.get('Content-Disposition'), 'wz-' + id + '.' + format),
    };
}
